import * as tslib_1 from "tslib";
import { ElementRef, OnDestroy, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { FcPaginatorComponent } from '@core/components/fc-paginator/fc-paginator.component';
import { LocationService } from 'app/main/locations/services/location.service';
import { chunk } from 'lodash';
import { Subject } from 'rxjs';
import { debounceTime, switchMap, takeUntil, tap } from 'rxjs/operators';
var LinkGroupsComponent = /** @class */ (function () {
    function LinkGroupsComponent(data, dialogRef, locationService) {
        this.data = data;
        this.dialogRef = dialogRef;
        this.locationService = locationService;
        this.page = null;
        this.searchInput = new FormControl();
        this.isLoading = true;
        this.isSaving = false;
        this.isAllSelected = false;
        this.currentPage = 0;
        this.pageSize = 5;
        this.isPageChanging = false;
        this.groupsToAdd = new Map();
        this.reload = new Subject();
        this.removeSubscriptions = new Subject();
        this.location = data.location;
    }
    LinkGroupsComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.searchInput.valueChanges.pipe(debounceTime(500)).subscribe(function () {
            _this.isLoading = true;
            if (_this.paginator) {
                _this.paginator.firstPage();
            }
            else {
                _this.reload.next();
            }
        });
        this.reload.pipe(takeUntil(this.removeSubscriptions), tap(function () { return _this.isLoading = true; }), switchMap(function () { return _this.searchGroups(); }), tap(function () {
            _this.isLoading = false;
        })).subscribe(function (page) {
            _this.page = page;
            _this.form.nativeElement.scrollTo({ top: 0 });
        });
        this.reload.next();
    };
    LinkGroupsComponent.prototype.ngOnDestroy = function () {
        this.removeSubscriptions.next();
        this.removeSubscriptions.complete();
    };
    LinkGroupsComponent.prototype.toggleSegmentLinkedToGroup = function (checked, group) {
        if (this.groupsToAdd.has(group.id)) {
            this.groupsToAdd.delete(group.id);
        }
        else {
            this.groupsToAdd.set(group.id, checked);
        }
        this.isAllSelected = this.checkIfIsAllSelected();
    };
    LinkGroupsComponent.prototype.searchGroups = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, this.locationService.listGroups({
                        locationId: this.location.id,
                        limit: this.pageSize,
                        offset: this.currentPage * this.pageSize,
                        where: {
                            name_contains: this.searchInput.value,
                        }
                    })];
            });
        });
    };
    LinkGroupsComponent.prototype.toggleAllSelected = function (checked) {
        var e_1, _a;
        var groups = (this.page && this.page.items) || [];
        try {
            for (var groups_1 = tslib_1.__values(groups), groups_1_1 = groups_1.next(); !groups_1_1.done; groups_1_1 = groups_1.next()) {
                var group = groups_1_1.value;
                if (!group.locationsConnection.items.length) {
                    this.toggleSegmentLinkedToGroup(checked, group);
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (groups_1_1 && !groups_1_1.done && (_a = groups_1.return)) _a.call(groups_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        this.isAllSelected = this.checkIfIsAllSelected();
    };
    LinkGroupsComponent.prototype.checkIfIsAllSelected = function () {
        var _this = this;
        var groups = (this.page && this.page.items) || [];
        return groups.length && groups.every(function (group) { return group.locationsConnection.items.length || _this.groupsToAdd.has(group.id); });
    };
    LinkGroupsComponent.prototype.continue = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var keys, _a, _b, groupIds, e_2_1;
            var e_2, _c;
            return tslib_1.__generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        this.isSaving = true;
                        keys = Array.from(this.groupsToAdd.keys());
                        _d.label = 1;
                    case 1:
                        _d.trys.push([1, 6, 7, 8]);
                        _a = tslib_1.__values(chunk(keys, 100)), _b = _a.next();
                        _d.label = 2;
                    case 2:
                        if (!!_b.done) return [3 /*break*/, 5];
                        groupIds = _b.value;
                        return [4 /*yield*/, this.locationService.addLocationToGroup({
                                locationId: this.location.id,
                                groupIds: groupIds
                            })];
                    case 3:
                        _d.sent();
                        _d.label = 4;
                    case 4:
                        _b = _a.next();
                        return [3 /*break*/, 2];
                    case 5: return [3 /*break*/, 8];
                    case 6:
                        e_2_1 = _d.sent();
                        e_2 = { error: e_2_1 };
                        return [3 /*break*/, 8];
                    case 7:
                        try {
                            if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
                        }
                        finally { if (e_2) throw e_2.error; }
                        return [7 /*endfinally*/];
                    case 8:
                        this.isSaving = false;
                        this.dialogRef.close({
                            reload: true
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    LinkGroupsComponent.prototype.onPageChange = function (event) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.isPageChanging = true;
                        this.currentPage = event.pageIndex;
                        _a = this;
                        return [4 /*yield*/, this.searchGroups()];
                    case 1:
                        _a.page = _b.sent();
                        this.isAllSelected = this.checkIfIsAllSelected();
                        this.form.nativeElement.scrollTo({ top: 0 });
                        this.isPageChanging = false;
                        this.isLoading = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    return LinkGroupsComponent;
}());
export { LinkGroupsComponent };
